import React from "react";
import { Link } from "react-router";

import styles from "./Conditions.module.scss";
import PreviousPage from "../../../partials/PreviousPage/PreviousPage";

const Conditions: React.FC = () => {
  return (
    <section className={styles.conditions}>
      <div className="container">
        <PreviousPage currentPage="Условия возврата" title="Возврат" />
        <div className={styles.goodsReturn}>
          <p className={styles.text}>
            Ткани, отпускаемые на метраж, а также иные текстильные товары надлежащего качества возврату и обмену не подлежат в
            соответствии с Постановлением Правительства РФ № 2463. Претензии по качеству и/или количеству приобретённого товара
            принимаются к рассмотрению в сроки, установленные действующим законодательством Российской Федерации. При обнаружении
            недостатков по количеству или комплектности покупателю рекомендуется уведомить магазин в течение 7 (семи) рабочих дней
            с момента получения заказа.
          </p>
        </div>
        <div className={styles.goodsCondition}>
          <h2 className="title">Условия возврата</h2>
          <ul className={styles.list}>
            <div className={styles.left}>
              <li className={styles.item}>
                На основании Постановления Правительства РФ от 31.12.2020 N 2463 «Об утверждении Правил продажи товаров по
                договору розничной купли-продажи, перечня товаров длительного пользования, на которые не распространяется
                требование потребителя о безвозмездном предоставлении ему товара, обладающего этими же основными потребительскими
                свойствами, на период замены такого товара, и перечня непродовольственных товаров надлежащего качества, не
                подлежащих обмену, а также о внесении изменений в некоторые акты Правительства Российской Федерации»: текстильные
                товары, отпускаемые на метраж (ткани, а также ленты, тесьма, кружево и другие аналогичные материалы), надлежащего
                качества возврату и обмену не подлежат. Этот запрет не ограничивает права покупателя, если товар ненадлежащего
                качества или не соответствует заказу.
              </li>
              <li className={styles.item}>
                При заказе через сайт просим внимательно читать описание ткани, рекомендации изделий, для пошива которых она
                подходит, состав, ширину и тд. Также учитывайте, что цветопередача может отличаться от действительности. Это
                зависит от модели и экрана вашего устройства, а также вашего цветовосприятия. В процессе оформления заказа вы
                можете попросить менеджера предоставить дополнительные фото и видео.
              </li>
              <li className={styles.item}>
                В случае наличия дефектов или не соответствия тканей заявленным характеристикам, менеджер обязан сообщить вам об
                этом во время комплектации заказа. В некоторых случаях возможен вариант уценки товара или замена аналогичным по
                договоренности с покупателем.
              </li>
            </div>
            <div className={styles.right}>
              <li className={styles.item}>
                При покупке тканей рулонами (фабричной намотки) разбраковка и перемер тканей НЕ ПРОИЗВОДИТСЯ! Это компенсируется
                оптовой ценой. При необходимости возможен перемер и разбраковка рулона — с соответсвующей наценкой за каждый
                погонный метр.
              </li>
              <li className={styles.item}>
                Если полученный товар надлежащего качества был раскроен, возврат и обмен такого товара не производятся. Претензии
                по недостаткам товара и по несоответствию заказу принимаются в сроки, установленные законодательством Российской
                Федерации. В случае возникновения вопросов относительно качества, комплектации или несоответствия заказанных вами
                материалов, просим связаться с менеджером, который оформлял заказ.
              </li>
              <li className={styles.item}>
                При возврате товара ненадлежащего качества денежные средства, уплаченные покупателем, возвращаются не позднее 10
                (десяти) дней с момента предъявления соответствующего требования.
              </li>
              <div className={styles.button}>
                <Link to="/write-to-us">Отправить претензию</Link>
              </div>
              <p className={styles.consent}>
                Нажимая кнопку, я даю согласие на обработку моих персональных данных с целью рассмотрения досудебной претензии и
                возврата денежных средств в соответствии с <Link to="/privacy">Политикой конфиденциальности</Link>
              </p>
            </div>
          </ul>
        </div>
      </div>
    </section>
  );
};

export default Conditions;
